module.exports = __webpack_public_path__ + "static/media/fk.eba97bad.svg";